module.exports = __webpack_public_path__ + "static/media/family-in-park.bd80355e.jpg";